import { apiC2 } from '../../config/api'

export const deleteDraftForm = (idForm) => {
  return apiC2.post(`/preelegibility/deletedraft`, {
    idForm: idForm,
  })
}
